import { Layout, Menu, MenuProps, theme } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { css } from '@emotion/css';
import { useEffect, useState } from 'react';
import logo from '../assets/images/align_logo.svg';
import { RoutesTypes } from './routerTypes';
import { useAuth0 } from '@auth0/auth0-react';
import { useBackoffice } from '../backoffice/useBackoffice';

const { Header, Content } = Layout;

const RootLayout: React.FC = () => {
  const { isBackofficeOn } = useBackoffice();
  const { token } = theme.useToken();
  const { logout } = useAuth0();
  const { pathname } = useLocation();
  const [current, setCurrent] = useState(pathname.substring(1) || RoutesTypes.Customers);
  const [menu, setMenu] = useState([
    {
      key: 'customers',
      label: `Customers`,
    },
    {
      key: 'transfers',
      label: `Transfers`,
    },
    {
      key: 'organization',
      label: `Organization`,
    },
    {
      key: 'logout',
      label: `Log Out`,
    },
  ]);
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname === '/') {
      setCurrent(RoutesTypes.Customers);
      navigate(`/${RoutesTypes.Customers}`);
    }
  }, [pathname, navigate]);

  useEffect(() => {
    if (isBackofficeOn) {
      setMenu([
        {
          key: 'customers',
          label: `Customers`,
        },
        {
          key: 'transfers',
          label: `Transfers`,
        },

        {
          key: 'logout',
          label: `Log Out`,
        },
      ]);
    }
  }, [isBackofficeOn, setMenu]);

  const onClick: MenuProps['onClick'] = (e) => {
    if (e.key === 'logout') {
      logout({ logoutParams: { returnTo: window.location.origin } });
    } else {
      setCurrent(e.key);
      switch (e.key) {
        case 'customers':
          navigate(`/${RoutesTypes.Customers}`);
          break;
        case 'organization':
          navigate(`/${RoutesTypes.Organization}`);
          break;
        case 'transfers':
          navigate(`/${RoutesTypes.Transfers}`);
          break;
      }
    }
  };

  const logoStyles = css`
    color: ${token.colorPrimary};
    display: flex;
    align-items: center;

    img {
      width: 82px;
    }
  `;

  const menuStyles = css`
    flex: 1;
    justify-content: flex-end;
    border: none;
  `;

  const contentStyles = css`
    background-color: ${token.colorWhite};
    padding: 24px 48px;
  `;

  return (
    <Layout>
      <Header
        style={{
          zIndex: 1,
          display: 'flex',
          boxShadow: token.boxShadowTertiary,
          backgroundColor: token.colorWhite,
          alignItems: 'center',
        }}
      >
        <div className={logoStyles}>
          <img src={logo} alt="Align Customer Portal" />
        </div>

        <Menu mode="horizontal" onClick={onClick} selectedKeys={[current]} items={menu} className={menuStyles} />
      </Header>
      <Content className={contentStyles}>
        <Outlet />
      </Content>
    </Layout>
  );
};

export default RootLayout;
